module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAAXNSR0IArs4c6QAAAJFJREFUGFdjPH78uObfv381OTg4NpuYmPxmgALGI0eOFDIxMTX///+/8NevX4sdHR1/gOQYjx8/rvD////pDAwMxgwMDDVPnjyZGxYW9pcRJHv48GE1ZmbmPkZGRuP///93PnnyZDJYAgQOHTokycLCsoWBgUGViYkpAr8EVqNwWg5zLgMDQ9HPnz8XITsXqwcBWyZYUcwXQuEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/xiang_qing.png
// module id = RMTz
// module chunks = 2